

export enum EntityType {
    Unit = "Unit",
    Driver = "Driver",
    Landmark = "Landmark",
    Geofence = "Geofence",
    Form = "Form",
    User = "User",
    Asset = "Asset",
    Tag = "Tag",
}

export interface Tag {
    id: number;
    label: string;
    color: string;
    parentId: number | null;
    path: string;
    hasChildren: boolean;
    disabled: boolean;
    unitsCount?: number;
    driversCount?: number;
    landmarksCount?: number;
    geofencesCount?: number;
    formsCount?: number;
    usersCount?: number;
    level?: number;
}


export interface EntityTagPickerBaseProps {
    entity: EntityType;
    height?: number;
    value?: any[];
    disableUntaggedSelection?: boolean;
    disableTagSelection: boolean;
    multiple: boolean;
    includeUnassignedDrivers: boolean;
    onChange: (newValue: any[], entity: EntityType) => void;
    tags: Tag[];
    units: any[];
    drivers: any[];
    landmarks: any[];
    geofences: any[];
    forms: any[];
    subusers: any[];
    assets: any[];
    loading: boolean;
    loadingEntities: boolean;
    messages: any;
    hideTagsWithoutEntities?: boolean;
    onlyTags?: boolean;
    inheritance?: boolean;
    enableSelectAll?: boolean;
    showOnlyEntity?: boolean;
}
  